import { useState } from 'react'
import { gql } from '@apollo/client'
import { useNavigate } from 'react-router-dom'
import { Table, Button, Alert } from 'reactstrap'
import { PROCESS_WORK_HISTORY_FILE_QUERY } from '../../../graphql'
import { FileUploadForm } from '../FileUploadForm'
import { handleGraphQLErrors, makeInteger } from '../../../utils'

export const PROCESS_WORK_HISTORY_FILE = gql(PROCESS_WORK_HISTORY_FILE_QUERY)

export default function WorkHistoryUpdate() {
  console.log('WorkHistoryUpdate rendered')

  const navigate = useNavigate()
  const [fileInfo, setFileInfo] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  async function processFile(fileName) {
    console.log('WorkHistoryUpdate.processFile', fileName)
    try {
      const { data, errors } = await window.apolloClient.query({ query: PROCESS_WORK_HISTORY_FILE, variables: { fileName: fileName } })
      console.log(data)
      if (data.processWorkHistoryFile) {
        setFileInfo(data.processWorkHistoryFile)
      }
      if (errors) {
        setGraphQLErrors(errors)
      }
    } catch (err) {
      handleGraphQLErrors(err, setGraphQLErrors)
    }
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  if (fileInfo) {
    if (fileInfo.errors.length > 0) {
      let errorItems = []
      for (let i = 0; i < fileInfo.errors.length; i++) {
        errorItems.push(<span key={i} style={{textAlign: 'center', fontWeight: 'normal'}}><b>Line: {fileInfo.errors[i].lineNumber}{fileInfo.errors[i].columnNumber ? `, column ${fileInfo.errors[i].columnNumber}` : ''}:</b> {fileInfo.errors[i].errorMessage}</span>)
        const fileContents = fileInfo.errors[i].fileContents
        console.log(fileContents)
        if (fileContents.length !== 1 && fileContents[0]) {
          const row = []
          for (let j = 0; j < fileContents.length; j++) {
            if (makeInteger(fileInfo.errors[i].columnNumber) === j+1) {
              row.push(<td key={j} style={{color: 'red'}}>{fileContents[j]}</td>)
            } else {
              row.push(<td key={j}>{fileContents[j]}</td>)
            }
          }
          errorItems.push(<Table bordered><tr key={i}>{row}</tr></Table>)
        }
      }
      return (
        <div className="custom-scroll timekeeper-table" >
          <form className="form">
            <div>
              {errorItems}
            </div>
            <h5 style={{ textAlign: 'center'}}>Please check your file and re-submit.</h5>
            <div className="custom-button-container">
              <Button color="primary" onClick={() => setFileInfo(null)}>Ok</Button>
            </div>
          </form>
        </div>
      )
    } else {
      return (
        <div className="custom-scroll" >
          <h5 style={{textAlign: 'center'}}><b>The work navigate file containing {fileInfo.numberOfItems} items was successfully loaded.</b></h5>
          <h5 style={{textAlign: 'center'}}><b>(Started: </b>{fileInfo.startTime}, <b>Finished: </b>{fileInfo.endTime}<b>)</b></h5>
          <div className="custom-button-container">
            <Button color="primary" onClick={() => navigate('/home')}>Ok</Button>
          </div>
        </div>
      )
    }
  }
  return <FileUploadForm setFileName={processFile} reportTitle='Plaintiff Work Histroy File Upload' reportMessage='Choose a file to upload:' />
}